"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppHandlerWeb = void 0;
const React = require("react");
const react_1 = require("react");
const urlParamsToObject_1 = require("../../../../helpers/urlParamsToObject");
const ErrorBoundary_1 = require("../../structure/ErrorBoundary");
const ErrorResolverHandler_1 = require("../ErrorResolverHandler");
const PersistenceHandler_1 = require("../../../../handlers/PersistenceHandler");
const ApiClientContext_1 = require("../../../../contexts/ApiClientContext");
const PlatformContext_1 = require("../../../../contexts/PlatformContext");
const ConfigContext_1 = require("../../../../contexts/ConfigContext");
const AppHandler_1 = require("../AppHandler");
/**
 * Handler specific for Web platform.
 *
 * It gets any config override as prop and is responsible for setting up
 * the Client provider and the Config provider based on the value returned by the onInit callback
 */
const AppHandlerWeb = ({ children, onInit, persistedSessionIdKey }) => {
    if (!onInit || (onInit && typeof onInit !== "function")) {
        throw new Error("AppHandlerWeb component expected to receive a valid onInit callback returning an array of type [configs, Client].");
    }
    const webConfig = Object.assign(Object.assign({}, env), (0, urlParamsToObject_1.urlParamsToObject)());
    const platformComponents = {
        ErrorBoundary: ErrorBoundary_1.ErrorBoundary,
        ErrorResolverHandler: ErrorResolverHandler_1.ErrorResolverHandler,
        PersistenceHandler: PersistenceHandler_1.PersistenceHandler
    };
    const _AppHandlerWeb = (0, react_1.useCallback)(() => {
        const [config, client] = onInit(webConfig);
        return (React.createElement(ApiClientContext_1.ApiClientContext.Provider, { value: { client } },
            React.createElement(ConfigContext_1.ConfigContext.Provider, { value: { config } },
                React.createElement(PlatformContext_1.PlatformContext.Provider, { value: { components: platformComponents } },
                    React.createElement(AppHandler_1.AppHandler, { persistedSessionIdKey: persistedSessionIdKey }, children)))));
    }, [onInit, platformComponents, persistedSessionIdKey, children]);
    return (React.createElement(ErrorBoundary_1.ErrorBoundary, null,
        React.createElement(_AppHandlerWeb, null)));
};
exports.AppHandlerWeb = AppHandlerWeb;
//# sourceMappingURL=index.js.map